'use client'
import CompanyLocationFilter from '@/app/[lng]/(home)/search/(Filters)/CommonFilters/CompanyLocationFilter'
import {
  addOrRemoveRetailCompanyContinent,
  addOrRemoveRetailCompanyCountry,
  addOrRemoveRetailCompanySelectedActivity,
  setRetailCompanyCountryFilter,
  setSelectAllRetailCompanyBuyers,
  setSelectAllRetailCompanySuppliers,
} from '@/app/globalRedux/filter/retail/retailCompanyFilter'
import { RootState } from '@/app/globalRedux/store'
import { CompanyResponse } from '@/app/types/companySearchType'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ClearAllRetailFilters from '../../../(components)/ClearAllRetailFilters'
import ActivitiesFilter from './ActivitiesFilter'

const RetailCompanyFilters = ({
  companyData,
  modalApplicable,
  showClearAll,
  modalFilterLayout,
}: {
  companyData: CompanyResponse
  modalApplicable: boolean
  showClearAll: boolean
  modalFilterLayout: boolean
}) => {
  const dispatch = useDispatch()

  const retailCompanyFilter = useSelector(
    (state: RootState) => state.retailCompanyFilter
  )

  const [companyLocation, setCompanyLocationText] = useState<string>('')

  return (
    <div
      className={`${!modalFilterLayout ? 'flex flex-col gap-5 w-[299px] mobile:w-[360px]' : ''}`}
      suppressHydrationWarning
    >
      <div
        className={`${modalApplicable ? 'opacity-50 pointer-events-none cursor-not-allowed' : ''} `}
      >
        <div className={`${modalFilterLayout ? 'grid grid-cols-2 gap-8' : ''}`}>
          <div>
            {showClearAll && <ClearAllRetailFilters />}
            <ActivitiesFilter
              selectedActivities={retailCompanyFilter?.retailSelectedActivity}
              setAllBuyers={() => {
                dispatch(setSelectAllRetailCompanyBuyers())
              }}
              setAllSuppliers={() => {
                dispatch(setSelectAllRetailCompanySuppliers())
              }}
              setValue={(value) => {
                dispatch(addOrRemoveRetailCompanySelectedActivity(value))
              }}
              countList={companyData?.facet_count?.activites_english}
              modalApplicable={modalApplicable}
            />
          </div>
          <div>
            <CompanyLocationFilter
              searchTitle={'Retail Location'}
              locationText={companyLocation}
              setLocationText={setCompanyLocationText}
              continentSelectedList={
                retailCompanyFilter?.retailCompanyFilterContienent
              }
              countrySelectedList={
                retailCompanyFilter?.retailCompanyFilterCountry
              }
              setWholeLocation={setRetailCompanyCountryFilter}
              addOrRemoveSelectedCountryList={addOrRemoveRetailCompanyCountry}
              addOrRemoveSelectedContinentList={
                addOrRemoveRetailCompanyContinent
              }
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default RetailCompanyFilters
